const Types = {
  SET_THEME: 'SET_THEME',
  SET_CONFIG: 'SET_CONFIG',
  SET_COMPANY: 'SET_COMPANY',
  SET_VERIFY_TOKEN: 'SET_VERIFY_TOKEN'
}

export default Types
